<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<p class="center ">First Mariner Books edition 2015</p>
<div class="timebreak "> </div>
<p class="center ">Copyright © 2014 by Rory Flynn</p>
<div class="timebreak "> </div>
<p class="center ">All Rights Reserved</p>
<div class="timebreak "> </div>
<p class="center ">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<div class="timebreak "> </div>
<p class="center ">
<a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a>
</p>
<div class="timebreak "> </div>
<p class="center ">
<em>The Library of Congress has cataloged the print edition as follows:</em>
</p>
<p class="center ">Flynn, Rory, date.</p>
<p class="center ">Third rail : an Eddy Harkness novel / by Rory Flynn.</p>
<p class="center ">pages cm</p>
<p class="center "><span class="smallcaps">ISBN</span> 978-0-544-22627-2 (hardback) <span class="smallcaps">ISBN</span> 978-0-544-48392-7 (pbk.)</p>
<p class="center ">1. Police—Fiction. 2. Designer drugs—Fiction. 3. Drug traffic—Fiction. 4. Boston (Mass.)—Fiction. I. Title.</p>
<p class="center ">PS3556.I816T45 2014</p>
<p class="center ">813'.54—dc23</p>
<p class="center ">2013021744</p>
<div class="timebreak "> </div>
<p class="center ">Cover design by Brian Moore<br/>
Cover images © Steven Weinberg/Getty Images (Boston skyline); Mike Kemp/Getty Images (Glock); WIN-Initiative/Getty Images (bridge)</p>
<div class="timebreak "> </div>
<p class="center ">e<span class="smallcaps">ISBN</span> 978-0-544-23289-1<br/>
v3.0516</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?62f986e6